<div id="switchcomponent" (click)="reverse()">
  <div class="switchtag" [ngStyle]="styleclass">
    <span [ngStyle]="spamclass"></span>
  </div>
  <div class="switchlabel">
    <ng-content></ng-content>
  </div>
</div>
